

import React from 'react';

const steps = [
    {
        title: 'BUY A COMMUNITY TOKEN',
        subTitle: "You'll get a tradable token now (1:1 redeemable for $OSCAR)."
    },
    {
        title: 'JOIN THE DUMPSTER',
        subTitle: 'Toss your rekt token to earn bonus > $OSCAR points'
    },
    {
        title: 'Redeem Your $OSCAR',
        subTitle: 'When $OSCAR launches, swap your presale token for real $OSCAR'
    }
];
const PresaleInfo = () => {

    return (

        <div style={{ marginTop: 80 }}>
            <h2 style={{ color: '#fff', fontSize: 45, marginBottom: 40 }}>HOW IT WORKS</h2>
            <div className="row">
                {steps.map((step, index) => (
                    <div className="col-md-6" key={index} style={{ marginBottom: 30 }}>
                        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                            <div style={{ fontSize: 55, fontWeight: 'bold', color: '#749d1a', marginRight: 20, minWidth: 50 }}>{index + 1}</div>
                            <div>
                                {step.title && <h4 style={{ fontSize: 28, color: '#efbc00', marginBottom: 10 }}>{step.title}</h4>}
                                <p style={{ fontSize: 22, color: '#ccc', maxWidth: 400 }}>{step.subTitle}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PresaleInfo;
